import { render, staticRenderFns } from "./transferGoodsManageList.vue?vue&type=template&id=5010a8de&scoped=true"
import script from "./transferGoodsManageList.vue?vue&type=script&lang=js"
export * from "./transferGoodsManageList.vue?vue&type=script&lang=js"
import style0 from "./transferGoodsManageList.vue?vue&type=style&index=0&id=5010a8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5010a8de",
  null
  
)

export default component.exports